(function () {
  function toNumber(value, fallback = 0) {
    const number = parseInt(value || fallback, 10);
    return Number.isNaN(number) ? fallback : number;
  }

  function getSectionFromElement(element) {
    return element.closest('.shopify-section') || document;
  }

  function getInputs(section) {
    return Array.from(section.querySelectorAll('[data-moq-gros-input]'));
  }

  function getButton(section) {
    return section.querySelector('[data-moq-gros-add-to-cart]');
  }

  async function refreshHorizonCart() {
  const response = await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error('Impossible de rafraîchir le panier');
  }

  const cart = await response.json();

  document.dispatchEvent(
    new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: {
          ...cart,
          item_count: getPackCartCountFromItems(cart.items || [])
        },
        data: {
          ...cart,
          itemCount: getPackCartCountFromItems(cart.items || []),
          source: 'moq-gros-batch-add'
        }
      }
    })
  );

  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        cart: cart
      }
    })
  );

  updateCartCountFallback(getPackCartCountFromItems(cart.items || []));
}

function updateCartCountFallback(itemCount) {
  const countElements = document.querySelectorAll(
    '[data-cart-count], .cart-bubble__text-count, .cart-count, .cart-count-bubble, [id*="cart-count"], [class*="cart-count"]'
  );

  countElements.forEach((element) => {
    element.textContent = itemCount;
    element.hidden = itemCount === 0;
  });
}

function openCartDrawerFallback() {
  const cartDrawerComponent = document.querySelector('cart-drawer-component');
  const cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawerComponent && typeof cartDrawerComponent.open === 'function') {
    cartDrawerComponent.open();
    return;
  }

  if (cartDrawer) {
    cartDrawer.open = true;
  }
}

  function getSelectedItems(inputs) {
    return inputs
      .map((input) => {
        return {
          input,
          id: toNumber(input.dataset.variantId, 0),
          quantity: toNumber(input.value, 0),
          title: input.dataset.variantTitle || ''
        };
      })
      .filter((item) => item.id > 0 && item.quantity > 0);
  }

  function validateInputs(section) {
    const inputs = getInputs(section);
    const selectedItems = getSelectedItems(inputs);
    const errors = [];

    if (selectedItems.length === 0) {
      return {
        valid: false,
        message: 'Sélectionnez des quantités',
        items: []
      };
    }

    selectedItems.forEach((item) => {
      const input = item.input;
      const qty = item.quantity;
      const moqType = input.dataset.moqType;
      const variantMoq = toNumber(input.dataset.variantMoq, 0);
      const variantIncrement = toNumber(input.dataset.variantIncrement, 1);

      if (variantIncrement > 1 && qty % variantIncrement !== 0) {
        const missing = variantIncrement - (qty % variantIncrement);
        errors.push(`Il manque ${missing} unité(s) sur ${item.title}.`);
      }

      if (moqType === 'variant' && variantMoq > 0 && qty < variantMoq) {
        const missing = variantMoq - qty;
        errors.push(`Il manque ${missing} unité(s) sur ${item.title}.`);
      }
    });

    const totalsByProduct = {};

    selectedItems.forEach((item) => {
      const input = item.input;

      if (input.dataset.moqType !== 'product_total') {
        return;
      }

      const productId = input.dataset.productId;
      const productMoq = toNumber(input.dataset.productMoq, 0);
      const productIncrement = toNumber(input.dataset.productIncrement, 1);

      if (!totalsByProduct[productId]) {
        totalsByProduct[productId] = {
          total: 0,
          moq: productMoq,
          increment: productIncrement
        };
      }

      totalsByProduct[productId].total += item.quantity;
    });

    Object.values(totalsByProduct).forEach((rule) => {
      if (rule.moq > 0 && rule.total < rule.moq) {
        const missing = rule.moq - rule.total;
        errors.push(`Il manque ${missing} unité(s) pour atteindre le MOQ.`);
      }

      if (rule.increment > 1 && rule.total % rule.increment !== 0) {
        const missing = rule.increment - (rule.total % rule.increment);
        errors.push(`Il manque ${missing} unité(s) pour atteindre le prochain multiple.`);
      }
    });

    if (errors.length > 0) {
      return {
        valid: false,
        message: [...new Set(errors)][0],
        items: selectedItems
      };
    }

    return {
      valid: true,
      message: 'Ajouter au panier',
      items: selectedItems
    };
  }

  function updateButton(section) {
    const button = getButton(section);

    if (!button) {
      return;
    }

    const result = validateInputs(section);

    button.textContent = result.message;
    button.disabled = !result.valid;

    if (result.valid) {
      button.classList.add('moq-gros-add-button--ready');
      button.classList.remove('moq-gros-add-button--disabled');
    } else {
      button.classList.remove('moq-gros-add-button--ready');
      button.classList.add('moq-gros-add-button--disabled');
    }
  }

  function normalizeInputValue(input) {
    const qty = toNumber(input.value, 0);

    if (qty < 0) {
      input.value = 0;
    }
  }

  function resetQuickOrder(section) {
  getInputs(section).forEach((input) => {
    input.value = 0;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const addButton = getButton(section);

  if (addButton) {
    addButton.disabled = true;
    addButton.textContent = 'Sélectionnez des quantités';
    addButton.classList.remove('moq-gros-add-button--ready');
    addButton.classList.add('moq-gros-add-button--disabled');
  }
}

function getPackCartCountFromItems(items) {
  const bundleIds = new Set();
  let regularCount = 0;

  items.forEach((item) => {
    const properties = item.properties || {};
    const bundleId = properties._bundle_id;

    if (bundleId) {
      bundleIds.add(bundleId);
    } else {
      regularCount += item.quantity || 0;
    }
  });

  return bundleIds.size + regularCount;
}

function updatePackCartCount() {
  fetch(window.Shopify.routes.root + 'cart.js', {
    headers: {
      Accept: 'application/json'
    }
  })
    .then((response) => response.json())
    .then((cart) => {
      const count = getPackCartCountFromItems(cart.items || []);

      document
        .querySelectorAll('.cart-bubble__text-count, [data-cart-count]')
        .forEach((element) => {
          element.textContent = count;
        });
    })
    .catch(() => {});
}

  document.addEventListener('input', function (event) {
    const input = event.target;

    if (!input.matches('[data-moq-gros-input]')) {
      return;
    }

    normalizeInputValue(input);
    updateButton(getSectionFromElement(input));
  });

  document.addEventListener('click', function (event) {
    const minus = event.target.closest('[data-moq-gros-minus]');
    const plus = event.target.closest('[data-moq-gros-plus]');
    const addButton = event.target.closest('[data-moq-gros-add-to-cart]');

    if (minus || plus) {
      const wrapper = event.target.closest('.moq-gros-quantity');
      const input = wrapper ? wrapper.querySelector('[data-moq-gros-input]') : null;

      if (!input) {
        return;
      }

      const step = toNumber(input.dataset.variantIncrement, 1);
      const current = toNumber(input.value, 0);

      if (minus) {
        input.value = Math.max(0, current - step);
      }

      if (plus) {
        input.value = current + step;
      }

      updateButton(getSectionFromElement(input));
      return;
    }

    if (!addButton) {
      return;
    }

    const section = getSectionFromElement(addButton);
    const result = validateInputs(section);

    if (!result.valid) {
      updateButton(section);
      return;
    }

    const bundleId = `pack-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
const bundleTitle = addButton.dataset.bundleTitle || 'Pack';
const bundleSummary = result.items
  .map((item) => `${item.quantity} × ${item.title}`)
  .join(' | ');

const items = result.items.map((item) => ({
  id: item.id,
  quantity: item.quantity,
  properties: {
    _bundle_id: bundleId,
    _bundle_title: bundleTitle,
    _bundle_summary: bundleSummary,
    _bundle_component_title: item.title,
    _bundle_component_quantity: String(item.quantity)
  }
}));

    addButton.disabled = true;
    addButton.textContent = 'Ajout en cours...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erreur ajout panier');
        }

        return response.json();
      })
      
      .then(() => {
  return refreshHorizonCart();
})
.then(() => {
  resetQuickOrder(section);

  addButton.textContent = 'Pack ajouté au panier';

  updatePackCartCount();

  setTimeout(() => {
    updateButton(section);
  }, 1200);
})
      .catch(() => {
        addButton.textContent = 'Erreur — réessayer';
        addButton.disabled = false;
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-moq-gros-add-to-cart]').forEach((button) => {
      updateButton(getSectionFromElement(button));
    });
  });
})();